/* eslint-disable @typescript-eslint/no-empty-function */
import { IListRequest } from 'data/models/common.model';
import {
  DataGrid,
  DataGridProps,
  GridPaginationModel,
  GridSortModel,
} from '@mui/x-data-grid';
import React from 'react';
type TTableProps = DataGridProps & {
  hasBackground?: boolean;
  filter?: IListRequest;
  onFilterChange?: (params: IListRequest) => void;
};

const Table = ({
  hasBackground = false,
  filter = { page: 0, pageSize: 50 },
  onFilterChange = () => {},
  ...props
}: TTableProps) => {
  const { page, pageSize, sortBy, order } = filter || {};
  const additionalProps =
    props.paginationMode === 'server'
      ? {
          paginationModel: { page, pageSize },
          onPaginationModelChange: (model: GridPaginationModel) => {
            onFilterChange({ ...filter, ...model });
          },
          hideFooter: (props.rowCount || 0) < 10,
          sortModel: sortBy && order ? [{ field: sortBy, sort: order }] : [],
          onSortModelChange: (model: GridSortModel) => {
            onFilterChange({
              ...filter,
              sortBy: model[0] ? model[0].field : undefined,
              order: model[0] ? model[0].sort : undefined,
            });
          },
        }
      : {
          hideFooter: props.rows.length < 10,
        };
  return (
    <div style={{ height: 'auto', width: '100%' }}>
      <DataGrid
        disableColumnFilter={true}
        disableRowSelectionOnClick={true}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
              page: 0,
            },
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        rowHeight={56}
        {...additionalProps}
        {...props}
        sx={{
          width: '100%',
          borderColor: 'transparent',
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-row--lastVisible': {
            '& .MuiDataGrid-cell': {
              borderBottom: 'none',
            },
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: ' #fcfdff',
          },
          '& .MuiDataGrid-withBorderColor': {
            borderColor: (theme) => theme.palette.border.main,
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottomWidth: hasBackground ? 0 : '3px',
            backgroundColor: '#F8F9FB',
          },
          '& .MuiDataGrid-columnHeader': {
            outline: 'none !important',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#000000',
            fontWeight: 700,
            fontSize: '18px',
            lineHeight: '28px',
          },
          '& .MuiDataGrid-cell': {
            color: '#000000',
            fontWeight: 500,
            fontSize: '15px',
            cursor: 'pointer',
          },
          '& .MuiTablePagination-root': {
            color: (theme) => theme.palette.primary.main,
          },
          '& .MuiDataGrid-virtualScroller': {
            minHeight:
              props.rowCount === 0 && props.rows.length === 0
                ? '100px'
                : 'auto',
          },
          '& .MuiDataGrid-virtualScrollerContent': {
            minHeight: !props.rows?.length ? '100px !important' : '100%',
          },
          ...props.sx,
        }}
      />
    </div>
  );
};

export default Table;
